import { render } from "./PaymentsPage.vue?vue&type=template&id=cdc85ca2&scoped=true&ts=true"
import script from "./PaymentsPage.vue?vue&type=script&lang=ts"
export * from "./PaymentsPage.vue?vue&type=script&lang=ts"

import "./PaymentsPage.vue?vue&type=style&index=0&id=cdc85ca2&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdc85ca2"]])

export default __exports__